import { MoreHorizontal, TrendingUp } from "lucide-react";
import { Sparkline } from "../ui/Sparkline";
import { StatusIndicator } from "../ui/StatusIndicator";
import type { MarketingServerFixture } from "./marketingDashboardFixture";

/** One card in the marketing dashboard preview. Fictional data, presentational only. */
export function PreviewServerCard({ server }: { server: MarketingServerFixture }) {
  const stroke = server.tone === "violet" ? "var(--accent-violet)" : "var(--accent-cyan)";

  return (
    <article className="preview-server-card">
      <header className="preview-server-card-head">
        <h3>{server.name}</h3>
        <div className="preview-server-card-head-right">
          <StatusIndicator tone="ok" label="Healthy" />
          <span className="preview-icon-btn">
            <MoreHorizontal size={16} strokeWidth={1.6} absoluteStrokeWidth />
          </span>
        </div>
      </header>

      <p className="preview-server-card-id cell-mono">
        {server.id} &middot; {server.subspaces} subspaces
      </p>

      <Sparkline
        values={server.spark}
        width={260}
        height={48}
        stroke={stroke}
        className="preview-server-card-spark"
      />

      <dl className="preview-server-card-stats">
        <div>
          <dt>CCU</dt>
          <dd>
            {server.ccu}
            <span className="preview-stat-delta">
              <TrendingUp size={12} strokeWidth={1.7} absoluteStrokeWidth />
              {server.ccuDelta}
            </span>
          </dd>
        </div>
        <div>
          <dt>Region</dt>
          <dd>{server.region}</dd>
        </div>
        <div>
          <dt>Plan</dt>
          <dd className="preview-stat-plan">{server.plan}</dd>
        </div>
        <div>
          <dt>Uptime</dt>
          <dd className="preview-stat-ok">{server.uptime}</dd>
        </div>
      </dl>

      <span className="btn btn--ghost btn--sm preview-server-card-cta">Open server &rarr;</span>
    </article>
  );
}
